module.exports = __webpack_public_path__ + "static/media/timer-gray.ca3cdec4.svg";